import React from 'react';
import { Link } from 'gatsby';
import {
  Root,
  Container,
  Item,
  BottleImg,
  Note,
  Desc,
  IconList,
  IconItem,
  ItemTitle,
  Actions,
  Button,
  IconImg,
} from './Reserve.style';

const Reserve = ({
  leftImage,
  logoImage,
  note,
  description,
  icons = [],
  findNearbyLink,
  buyOnlineLink,
  backgroundColor,
  focusId
}) => {
  return (
    <Root bgColor={backgroundColor}>
      <Container>
        <Item className="--left">
          <BottleImg
            src={leftImage}
            alt="James Ownby Reserve Signature Bottle"
          />
        </Item>
        <Item className="--right">
          {logoImage && (
            <h2>
              <img src={logoImage} alt="James Ownby Reserve Limited Logo" />
            </h2>
          )}
          <Note id={focusId}>{note}</Note>
          <Desc dangerouslySetInnerHTML={{ __html: description }} />
          <IconList>
            {icons.map((icon, idx) => (
              <IconItem key={idx}>
                <IconImg src={icon.src} alt={''} />
                <ItemTitle>{icon.title}</ItemTitle>
              </IconItem>
            ))}
          </IconList>

          <Actions>
            {findNearbyLink && (
              <Button
                className="--solid"
                as={Link}
                to={findNearbyLink}
                onClick={() => {
                  setTimeout(() => {
                    const el = document.getElementById('location-search');
                    if (el) el.focus();
                  }, 100);
                }}
              >
                FIND NEARBY
              </Button>
            )}
            {buyOnlineLink && (
              <Button
                className="--outline"
                as={Link}
                to={buyOnlineLink}
                target="_blank"
              >
                BUY ONLINE
              </Button>
            )}
          </Actions>
        </Item>
      </Container>
    </Root>
  );
};

export default Reserve;
